import { useMutation } from "@tanstack/react-query"
import apiClient from "./apiClient"

export interface FeedbackPayload {
  feedbackText: string
  feedbackType: "general" | "bug" | "feature_request"
  rating?: number
  attachments?: File[]
}

interface FeedbackResponse {
  success: boolean
  message: string
}

const feedbackApiCalls = {
  submitFeedback: async (
    payload: FeedbackPayload,
  ): Promise<FeedbackResponse> => {
    if (payload.feedbackType === "bug") {
      const formData = new FormData()
      formData.append("feedback_text", payload.feedbackText)
      formData.append("feedback_type", payload.feedbackType)

      if (typeof payload.rating === "number") {
        formData.append("rating", String(payload.rating))
      }

      payload.attachments?.forEach((file) => {
        formData.append("attachments", file)
      })

      const response = await apiClient.post<FeedbackResponse>(
        "/feedback",
        formData,
      )
      return response.data
    }

    const response = await apiClient.post<FeedbackResponse>("/feedback", {
      feedbackText: payload.feedbackText,
      feedbackType: payload.feedbackType,
      rating: payload.rating,
    })
    return response.data
  },
}

export const useSubmitFeedback = () => {
  return useMutation<FeedbackResponse, Error, FeedbackPayload>({
    mutationFn: feedbackApiCalls.submitFeedback,
  })
}
